import { useMemo } from 'react';
import { BrannanNavigation } from '@graphql/generated-base';
import type { EventPageType } from '@graphql/generated-base';
import { useWelcomePage } from '@shared/hooks/useWelcomePage';

type UseIsCompactBrannanHeaderArgs = Readonly<{
  pages: ReadonlyArray<{ pageSlug?: string | null }> | undefined;
  pageSlug: string | undefined;
  currentPageType: EventPageType | undefined;
  brannanNavigation: BrannanNavigation | null | undefined;
}>;

/**
 * Computes whether a Brannan standalone background header should render in its
 * compact form (classic navigation, on a non-welcome page). Shared by the
 * background header layouts so the compact-view rule stays in one place.
 */
export const useIsCompactBrannanHeader = ({ pages, pageSlug, currentPageType, brannanNavigation }: UseIsCompactBrannanHeaderArgs) => {
  const { checkIsWelcomePage } = useWelcomePage();
  const { isWelcomePage } = checkIsWelcomePage(pageSlug, currentPageType);

  const pageIndex = useMemo(() => pages?.findIndex(p => p.pageSlug === pageSlug), [pages, pageSlug]);
  const isCompactView = brannanNavigation === BrannanNavigation.classic && !isWelcomePage && pageIndex !== 0;

  return { isWelcomePage, isCompactView };
};
